import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { emailRed } from "../../assets";
import Layout1 from "../../Layouts/Layout1";
import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
const AddAgency = () => {
  const navigate = useNavigate();
  const { isLoaded: isPlacesLoaded } = useJsApiLoader({
    id: "google-place-script-global",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_PLACES_API_KEY || "",
    libraries: ["places"],
  });
  const nigeriaPlacesOptions = {
    componentRestrictions: { country: "ng" },
  };
  const [primaryAddressAutocomplete, setPrimaryAddressAutocomplete] = useState(null);
  const [mailingAddressAutocomplete, setMailingAddressAutocomplete] = useState(null);
  const COLOR = "red";
  const [color, setColor] = useState(COLOR);

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const [Credentials, setCredentials] = useState("");
  const [Conform, setConform] = useState("");

  const [textAreaLength, setTextAreaLength] = useState();
  const [AgencyProfileDetails, setAgencyProfileDetails] = useState({
    street: "",
    suburb_area: "",
    postcode: "",
    state_region: "",
    country: "",
    mailing_address_street: "",
    mailing_address_suburb_area: "",
    mailing_address_postcode: "",
    mailing_address_state_region: "",
    mailing_address_country: "",
    fax: "",
    phone: "",
    email: "",
    web: "",
    facebook_page: "",
    twitter_profile_url: "",
    principal_name: "",
    display_email: "",
    office_description: "",
  });

  // const onChangeInput = (e) => {
  //   const { name, value } = e.target;
  //   setAgencyBranding({ ...AgencyBranding, [name]: value });
  // };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setAgencyProfileDetails({ ...AgencyProfileDetails, [name]: value });
  };
  const getAddressComponent = (components, type) => {
    const component = components?.find((item) => item.types?.includes(type));
    return component?.long_name || "";
  };

  const applyAddressFromPlace = (place, addressType) => {
    const formattedAddress = place?.formatted_address || "";
    const addressComponents = place?.address_components || [];
    const streetNumber = getAddressComponent(addressComponents, "street_number");
    const route = getAddressComponent(addressComponents, "route");
    const suburb =
      getAddressComponent(addressComponents, "sublocality_level_1") ||
      getAddressComponent(addressComponents, "locality");
    const postcode = getAddressComponent(addressComponents, "postal_code");
    const stateRegion = getAddressComponent(
      addressComponents,
      "administrative_area_level_1"
    );
    const country = getAddressComponent(addressComponents, "country");

    const streetValue = [streetNumber, route].filter(Boolean).join(" ");

    setAgencyProfileDetails((prev) => ({
      ...prev,
      ...(addressType === "primary"
        ? {
            street: streetValue || formattedAddress,
            suburb_area: suburb,
            postcode,
            state_region: stateRegion,
            country,
          }
        : {
            mailing_address_street: streetValue || formattedAddress,
            mailing_address_suburb_area: suburb,
            mailing_address_postcode: postcode,
            mailing_address_state_region: stateRegion,
            mailing_address_country: country,
          }),
    }));
  };

  const onPrimaryAddressPlaceChanged = () => {
    if (!primaryAddressAutocomplete) return;
    const place = primaryAddressAutocomplete.getPlace();
    if (place?.address_components) {
      applyAddressFromPlace(place, "primary");
    }
  };

  const onMailingAddressPlaceChanged = () => {
    if (!mailingAddressAutocomplete) return;
    const place = mailingAddressAutocomplete.getPlace();
    if (place?.address_components) {
      applyAddressFromPlace(place, "mailing");
    }
  };

  const AddNewAgency = async () => {
    try {
      if (AgencyProfileDetails?.street === "") {
        toast.error("Please enter Street");
      } else if (Conform !== Credentials) {
        toast.error("Current Password and confirm password not match");
      } else if (AgencyProfileDetails?.suburb_area === "") {
        toast.error("Please enter a Suburb Area");
      } else if (AgencyProfileDetails?.postcode === "") {
        toast.error("Please enter a Postcode");
      } else if (AgencyProfileDetails?.state_region === "") {
        toast.error("Please enter a State Region");
      } else if (AgencyProfileDetails?.suburb_area === "") {
        toast.error("Please enter a Country");
      } else if (AgencyProfileDetails?.country === "") {
        toast.error("Please enter a Suburb Area");
      } else if (AgencyProfileDetails?.mailing_address_street === "") {
        toast.error("Please enter a Mailing Address Street");
      } else if (AgencyProfileDetails?.mailing_address_suburb_area === "") {
        toast.error("Please enter a Mailing Address Suburb Area");
      } else if (AgencyProfileDetails?.mailing_address_postcode === "") {
        toast.error("Please enter a Mailing Address Postcode");
      } else if (AgencyProfileDetails?.mailing_address_state_region === "") {
        toast.error("Please enter a Mailing Address State Region");
      } else if (AgencyProfileDetails?.mailing_address_country === "") {
        toast.error("Please enter a Mailing Address Country");
      } else if (AgencyProfileDetails?.phone === "") {
        toast.error("Please enter a Phone");
      }
      // else if (AgencyProfileDetails?.web === "") {
      //   toast.error("Please enter a Web");
      // } else if (AgencyProfileDetails?.facebook_page === "") {
      //   toast.error("Please enter a Facebook Page URL");
      // } else if (AgencyProfileDetails?.twitter_profile_url === "") {
      //   toast.error("Please enter a Twitter Profile URL");
      // }
      else if (AgencyProfileDetails?.principal_name === "") {
        toast.error("Please enter a Agency Name");
      } else if (AgencyProfileDetails?.display_email === "") {
        toast.error("Please enter a valid Display Email");
      } else {
        const formData = new FormData();
        formData.append("role", "agency");
        formData.append("password", Credentials);
        formData.append("street", AgencyProfileDetails?.street);
        formData.append("suburb_area", AgencyProfileDetails?.suburb_area);
        formData.append("postcode", AgencyProfileDetails?.postcode);
        formData.append(
          "state_region",
          AgencyProfileDetails?.state_region?.value || AgencyProfileDetails?.state_region
        );
        formData.append(
          "country",
          AgencyProfileDetails?.country?.value || AgencyProfileDetails?.country
        );
        formData.append(
          "mailing_address_street",
          AgencyProfileDetails?.mailing_address_street
        );
        formData.append(
          "mailing_address_suburb_area",
          AgencyProfileDetails?.mailing_address_suburb_area
        );
        formData.append(
          "mailing_address_postcode",
          AgencyProfileDetails?.mailing_address_postcode
        );
        formData.append(
          "mailing_address_state_region",
          AgencyProfileDetails?.mailing_address_state_region?.value ||
            AgencyProfileDetails?.mailing_address_state_region
        );
        formData.append(
          "mailing_address_country",
          AgencyProfileDetails?.mailing_address_country?.value ||
            AgencyProfileDetails?.mailing_address_country
        );
        formData.append("phone", AgencyProfileDetails?.phone);
        formData.append("email", AgencyProfileDetails?.email);
        formData.append("web", AgencyProfileDetails?.web);
        formData.append("facebook_page", AgencyProfileDetails?.facebook_page);
        formData.append(
          "twitter_profile_url",
          AgencyProfileDetails?.twitter_profile_url
        );
        formData.append("principal_name", AgencyProfileDetails?.principal_name);
        formData.append("display_email", AgencyProfileDetails?.display_email);

        axiosInstanceAuthFormData
          .post(`admin/Agency/create`, formData)
          .then((res) => {
            if (res?.data?.status) {
              toast.success("Agency Added Successfuly");
              navigate(`/agency`);
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            console.log("------>> Error", err);
          });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Layout1>
      <div className="w-full bg-white rounded-t-xl">
        <div className="bg-[#E5002A] text-white font-semibold text-sm md:text-base lg:text-lg rounded-t-xl p-5">
          Agency Profile
        </div>

        <div className="p-6">
          <div className="text-black font-semibold text-sm md:text-base lg:text-lg my-4 mb-8">
            Mandatory fields are marked with an asterisk (
            <span className="text-[#E5002A]">*</span>)
          </div>

          {/* -------- credentials -------- */}
          <div className="font-semibold text-[#E5002A] my-5 md:my-8">
            Credentials
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Email :<span className="px-1 text-red-500">*</span>
              </div>

              <input
                type="email"
                value={AgencyProfileDetails?.email}
                name="email"
                onChange={onInputChange}
                placeholder="Enter Email"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Password :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="password"
                value={Credentials}
                name="password"
                autoComplete="new-password"
                onChange={(e) => {
                  setCredentials(e?.target?.value);
                }}
                placeholder="Enter Password"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Confirm Password :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="password"
                value={Conform}
                name="Conformpassword"
                autoComplete="new-password"
                onChange={(e) => {
                  setConform(e?.target?.value);
                }}
                placeholder="Enter Password"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>

          {/* -------- Address -------- */}
          <div className="font-semibold text-[#E5002A] my-5 md:my-8">
            Address
          </div>
          <div className="">
            <div className="font-medium text-[#171717] text-xs md:text-sm">
              Street : <span className="px-1 text-[#E5002A]">*</span>
            </div>
            {isPlacesLoaded ? (
              <Autocomplete
                onLoad={setPrimaryAddressAutocomplete}
                onPlaceChanged={onPrimaryAddressPlaceChanged}
                options={nigeriaPlacesOptions}
              >
                <input
                  type="text"
                  value={AgencyProfileDetails?.street}
                  name="street"
                  autoComplete="off"
                  onChange={onInputChange}
                  placeholder="Search address"
                  className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-3xl py-3 px-5  mt-3"
                />
              </Autocomplete>
            ) : (
              <input
                type="text"
                value={AgencyProfileDetails?.street}
                name="street"
                autoComplete="off"
                onChange={onInputChange}
                placeholder="Enter street"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-3xl py-3 px-5  mt-3"
              />
            )}
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Suburb/Area :<span className="px-1 text-red-500">*</span>
              </div>

              <input
                type="text"
                value={AgencyProfileDetails?.suburb_area}
                name="suburb_area"
                autoComplete="off"
                onChange={onInputChange}
                placeholder="Enter suburb area"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Postcode :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="number"
                value={AgencyProfileDetails?.postcode}
                name="postcode"
                autoComplete="off"
                onChange={onInputChange}
                placeholder="Enter postcode"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                State/Region :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.state_region}
                name="state_region"
                onChange={onInputChange}
                placeholder="Enter state/region"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Country :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.country}
                name="country"
                onChange={onInputChange}
                placeholder="Enter country"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
          {/* -------- Mailing Address -------- */}
          <div className="flex gap-3 font-semibold text-[#E5002A] my-5 md:my-8">
            Mailing Address
            <img src={emailRed} alt="img" />
          </div>
          <div className="font-medium text-[#737373] text-xs md:text-sm mb-4">
            These fields will only display on your specialized agency website.
            To update your agency billing address please contact Customer Care.
          </div>
          <div className="">
            <div className="font-medium text-[#171717] text-xs md:text-sm">
              Street/P.O. Box :
            </div>
            {isPlacesLoaded ? (
              <Autocomplete
                onLoad={setMailingAddressAutocomplete}
                onPlaceChanged={onMailingAddressPlaceChanged}
                options={nigeriaPlacesOptions}
              >
                <input
                  type="text"
                  value={AgencyProfileDetails?.mailing_address_street}
                  name="mailing_address_street"
                  onChange={onInputChange}
                  placeholder="Search mailing address"
                  autoComplete="off"
                  className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-3xl py-3 px-5  mt-3"
                />
              </Autocomplete>
            ) : (
              <input
                type="text"
                value={AgencyProfileDetails?.mailing_address_street}
                name="mailing_address_street"
                onChange={onInputChange}
                placeholder="Enter street"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-3xl py-3 px-5  mt-3"
              />
            )}
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Suburb/Area :
              </div>

              <input
                type="text"
                value={AgencyProfileDetails?.mailing_address_suburb_area}
                name="mailing_address_suburb_area"
                onChange={onInputChange}
                placeholder="Enter suburb area"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Postcode :
              </div>
              <input
                type="number"
                value={AgencyProfileDetails?.mailing_address_postcode}
                name="mailing_address_postcode"
                onChange={onInputChange}
                placeholder="Enter postcode"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                State/Region :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.mailing_address_state_region}
                name="mailing_address_state_region"
                onChange={onInputChange}
                placeholder="Enter state/region"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Country :<span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.mailing_address_country}
                name="mailing_address_country"
                onChange={onInputChange}
                placeholder="Enter country"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
          {/* -------- Contact Info -------- */}
          <div className="font-semibold text-[#E5002A] my-5 md:my-8">
            Contact Info
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            {/* <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Fax :
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.fax}
                name="fax"
                onChange={onInputChange}
                placeholder="Enter fax"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
              <div className="text-[#737373] text-xs md:text-sm p-2 ">
                If supplying a fax number, please include prefix as above.
              </div>
            </div> */}
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Phone : <span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="number"
                value={AgencyProfileDetails?.phone}
                name="phone"
                onChange={onInputChange}
                placeholder="Enter phone"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
              {/* <div className="text-[#737373] text-xs md:text-sm p-2 ">
                (Please include prefix, eg. 03 9555 1777 for Australian Agents,
                or 9 2673656 for New Zealand Agents.)
              </div> */}
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Email : <span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="email"
                value={AgencyProfileDetails?.email}
                name="email"
                onChange={onInputChange}
                placeholder="Enter email"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Web :
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.web}
                name="web"
                onChange={onInputChange}
                placeholder="Enter web"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Facebook Page :
              </div>
              <div className="w-full flex flex-row justify-start items-center gap-2 mt-3">
                <input
                  type="text"
                  value={AgencyProfileDetails?.facebook_page}
                  name="facebook_page"
                  onChange={onInputChange}
                  placeholder="Enter facebook page"
                  className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5"
                />
                {/* <img
                  src={questionMark}
                  alt="icon"
                  className="w-5 cursor-pointer"
                /> */}
              </div>
              {/* <div className="text-[#3B8FD4] font-semibold text-xs md:text-sm p-2 cursor-pointer">
                More about Facebook
              </div> */}
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Twitter Profile URL :
              </div>
              <div className="w-full flex flex-row justify-start items-center gap-2 mt-3">
                <input
                  type="text"
                  value={AgencyProfileDetails?.twitter_profile_url}
                  name="twitter_profile_url"
                  onChange={onInputChange}
                  placeholder="Enter twitter profile url"
                  className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5"
                />
                {/* <img
                  src={questionMark}
                  alt="icon"
                  className="w-5 cursor-pointer"
                /> */}
              </div>
              {/* <div className="text-[#3B8FD4] font-semibold text-xs md:text-sm p-2 cursor-pointer">
                More about Twitter
              </div> */}
            </div>
          </div>
          {/* -------- Wbsite Link -------- */}
          <div className="font-semibold text-[#E5002A] my-5 md:my-8">
            These fields will only display on your specialised agency website
          </div>
          <div className="flex flex-col md:flex-row justify-center gap-4 mt-4 md:mt-6">
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm ">
                Principal Name : <span className="px-1 text-red-500">*</span>
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.principal_name}
                name="principal_name"
                onChange={onInputChange}
                placeholder="Enter your principal name"
                autoComplete="off"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
            <div className="w-full">
              <div className="font-medium text-[#171717] text-xs md:text-sm">
                Display Email :
              </div>
              <input
                type="text"
                value={AgencyProfileDetails?.display_email}
                name="display_email"
                onChange={onInputChange}
                autoComplete="off"
                placeholder="Enter your display email"
                className="w-full font-medium text-[#737373] text-xs md:text-sm  outline-none border border-[#E5E5E5] rounded-[28px] py-3 px-5 mt-3"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-col justify-start bg-white rounded-b-2xl shadow-md text-[#404040] font-medium p-6 mb-10">
        {/* ----------- Button ---------- */}
        <div className="w-full flex justify-start items-center  text-white text-xs md:text-sm mt-4 md:mt-6">
          <button
            className="py-2 px-5 bg-[#E5002A] rounded-3xl"
            onClick={AddNewAgency}
          >
            Add Agency
          </button>
        </div>
      </div>
    </Layout1>
  );
};
export default AddAgency;
